(function reconcileStandardProductMedia(root) {
  const separator = "\u001f";
  const collisionSuffix =
    /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=(?:_\d+)?\.[^.]+$)/iu;

  function filenameFromUrl(value) {
    if (!value) return "";
    try {
      return decodeURIComponent(new URL(value, root.location.href).pathname.split("/").pop() || "");
    } catch (_error) {
      return "";
    }
  }

  function canonicalFilename(value) {
    return filenameFromUrl(value).replace(collisionSuffix, "");
  }

  function elementFilename(element) {
    const image = element.querySelector("img");
    return canonicalFilename(image?.currentSrc || image?.src || "");
  }

  function selectedOptions(contract) {
    const variantRoot = document.querySelector("variant-radios, variant-selects");
    if (!variantRoot) return [];
    const fieldsets = Array.from(variantRoot.querySelectorAll("fieldset"));
    const selects = Array.from(variantRoot.querySelectorAll("select"));
    return contract.o.map((_name, index) => {
      const checked = fieldsets[index]?.querySelector("input:checked");
      return checked?.value ?? selects[index]?.value ?? "";
    });
  }

  function orderedByContract(elements, sourceOrder) {
    const unused = Array.from(elements);
    const ordered = [];
    sourceOrder.forEach((sourceFilename) => {
      const canonical = canonicalFilename(sourceFilename);
      const index = unused.findIndex(
        (element) => elementFilename(element) === canonical,
      );
      if (index < 0) return;
      ordered.push(unused.splice(index, 1)[0]);
    });
    return ordered.concat(unused);
  }

  function applyVisibility(element, hidden) {
    element.hidden = hidden;
    element.classList.toggle("orthora-variant-media-hidden", hidden);
  }

  function reconcile() {
    if (document.querySelector("orthora-pdp-gallery")) return;
    const handle = decodeURIComponent(root.location.pathname.split("/products/")[1] || "").split("/")[0];
    const contract = root.OrthoraProductMediaMap?.p?.[handle];
    const mediaGallery = document.querySelector("media-gallery");
    if (!contract || !mediaGallery) return;

    const sourceOrder = contract.m.map(canonicalFilename);
    const variantFilenames = new Set(
      Object.values(contract.f).map(canonicalFilename),
    );
    const selectedFilename = canonicalFilename(
      contract.f[selectedOptions(contract).join(separator)] || "",
    );

    const slideList = mediaGallery.querySelector('[id^="Slider-Gallery-"] ul')
      || mediaGallery.querySelector('ul[id^="Slider-Gallery-"]');
    const thumbnailList = mediaGallery.querySelector('ul[id^="Slider-Thumbnails-"]')
      || mediaGallery.querySelector(".thumbnail-list");
    if (!slideList) return;

    const slides = orderedByContract(
      Array.from(slideList.children).filter((element) => element.matches('[id^="Slide-"]')),
      sourceOrder,
    );
    const selectedSlide = slides.find(
      (element) => elementFilename(element) === selectedFilename,
    );
    const commonSlides = slides.filter(
      (element) => !variantFilenames.has(elementFilename(element)),
    );
    const visibleSlides = selectedSlide
      ? [selectedSlide, ...commonSlides.filter((element) => element !== selectedSlide)]
      : commonSlides;
    const visibleSlideSet = new Set(visibleSlides);
    [...visibleSlides, ...slides.filter((element) => !visibleSlideSet.has(element))].forEach(
      (element) => {
        applyVisibility(element, !visibleSlideSet.has(element));
        slideList.append(element);
      },
    );

    if (thumbnailList) {
      const thumbnails = orderedByContract(
        Array.from(thumbnailList.children).filter((element) =>
          element.matches(".thumbnail-list__item"),
        ),
        sourceOrder,
      );
      const selectedThumbnail = thumbnails.find(
        (element) => elementFilename(element) === selectedFilename,
      );
      const commonThumbnails = thumbnails.filter(
        (element) => !variantFilenames.has(elementFilename(element)),
      );
      const visibleThumbnails = selectedThumbnail
        ? [selectedThumbnail, ...commonThumbnails.filter((element) => element !== selectedThumbnail)]
        : commonThumbnails;
      const visibleThumbnailSet = new Set(visibleThumbnails);
      [...visibleThumbnails, ...thumbnails.filter((element) => !visibleThumbnailSet.has(element))].forEach(
        (element) => {
          applyVisibility(element, !visibleThumbnailSet.has(element));
          thumbnailList.append(element);
        },
      );
    }

    if (selectedSlide && typeof mediaGallery.setActiveMedia === "function") {
      mediaGallery.setActiveMedia(selectedSlide.dataset.mediaId, true);
    }
  }

  document.addEventListener("change", (event) => {
    if (!event.target?.closest?.("variant-radios, variant-selects")) return;
    root.setTimeout(reconcile, 80);
  });
  document.addEventListener("shopify:section:load", reconcile);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reconcile, { once: true });
  } else {
    reconcile();
  }
})(globalThis);
